// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
const serveName = process.env.VUE_APP_SERVENAME

// 产品列表查询
export const queryProductList = (data?: any) => request(`/${serveName}/app/dimension`, {}, 'POST_JSON', data)

// 支付渠道列表查询
export const queryChannelList = (data: any) =>
  request(`/${serveName}/payDimension/selectDimensionByDbtId`, null, 'POST_JSON', data)

// 对账列表查询
export const queryBillList = (data: any) => request(`/${serveName}/reconciliation/list`, null, 'POST_JSON', data)

// 对账明细列表查询
export const queryBillDetailList = (data: any) =>
  request(`/${serveName}/reconciliation/detail`, null, 'POST_JSON', data)

// 订单明细列表查询
export const queryOrderDetailList = (data: any) =>
  request(`/${serveName}/reconciliation/pay/detail`, null, 'POST_JSON', data)

// IOS明细列表查询
export const queryIosDetailList = (data: any) =>
  request(`/${serveName}/reconciliation/third/detail`, null, 'POST_JSON', data)
